<template>
  <div>
    <PartnershipNavbar v-if="header" :slice="header" />
    <component :is="slice.slice_type" v-for="(slice, sliceIndex) in slices" :key="sliceIndex" :slice="slice" />
  </div>
</template>

<script>
import { TrustpilotCarousel, HeroLaunch, FaqSlice, HighlightText, HighlightSection, SimpleCta, LogoList } from '@@/shared-slices'

import {
  HighlightBlockSlice,
  QuinconceSlice,
  ArticlesList,
  HorizontalListSlice,
  VimeoSection,
  ScrollableList,
  BundleProductSlice,
  ButtonSlice,
  EmbedCalendly,
  BottomBanner,
  HeroFullImage,
  GivebackSchema,
} from '~/components/slices'

import PartnershipNavbar from './components/PartnershipNavbar'

export default {
  name: 'LaunchModule',

  components: {
    PartnershipNavbar,
    quinconce_block: QuinconceSlice,
    highlight_text: HighlightText,
    highlight_block: HighlightBlockSlice,
    highlight_section: HighlightSection,
    trustpilot_carousel: TrustpilotCarousel,
    faq_slice: FaqSlice,
    simple_cta: SimpleCta,
    hero_launch: HeroLaunch,
    article_list: ArticlesList,
    scrollable_list: ScrollableList,
    horizontal_list: HorizontalListSlice,
    vimeo_section: VimeoSection,
    bundle_product: BundleProductSlice,
    cta_section: ButtonSlice,
    embed_calendly: EmbedCalendly,
    bottom_banner: BottomBanner,
    hero_full_image: HeroFullImage,
    giveback_schema: GivebackSchema,
    logo_list: LogoList,
  },

  props: {
    moduleData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      slices: this.moduleData.body.filter((s) => s.slice_type !== 'partnership_navbar'),
      header: this.moduleData.body.find((slice) => slice.slice_type === 'partnership_navbar'),
    }
  },
}
</script>
